import { FormFlow } from '../../../components/FormFlow/FormFlow';
import { CancelSessionConfirm } from './Confirm';
import Success from './Success/Success';
import SuccessWithVoucher from './Success/SuccessWithVoucher';

const CancelSession = () => {
  const formElements = {
    '': CancelSessionConfirm,
    success: Success,
    'success-with-voucher': SuccessWithVoucher,
  };

  return <FormFlow elements={formElements} />;
};

export default CancelSession;
